import React from "react";

const SystemcodeContext = React.createContext({
  systemcode: "",
  setSystemcode: () => {},
});

export default SystemcodeContext;
